import Breadcrumb from "components/Common/Breadcrumb2"
import OffCanvasFilter from "components/OffCanvasFilter/OffCanvasFilter"
import PropTypes from "prop-types"
import React, { useState } from "react"
import { withTranslation } from "react-i18next"
import { Col, Container, Row } from "reactstrap"
import EntregaTransp from "./Components/EntregaTransp"
import EntregaUF from "./Components/EntregaUF"
import PedidosPorTranspXUF from "./Components/PedidosPorTranspXUF"

const TempoMedio = props => {
  document.title = "Tempo Médio | Sensetek"

  const [showFilter, setShowFilter] = useState(false)

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title={props.t("Tempo Médio")}
            breadcrumbItems={[{ title: props.t("Indicadores"), path: "#" }]}
          />
          <Row>
            <Col className="d-flex flex-row-reverse">
              <button
                className="btn filter-item noti-icon right-bar-toggle text-end"
                type="button"
                onClick={() => {
                  setShowFilter(true)
                }}
              >
                <i className="bx bx-filter" />
              </button>
              <OffCanvasFilter
                showFilter={showFilter}
                setShowFilter={setShowFilter}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={4}>
              <PedidosPorTranspXUF />
            </Col>
            <Col sm={4}>
              <EntregaUF />
            </Col>
            <Col sm={4}>
              <EntregaTransp />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

TempoMedio.propTypes = {
  t: PropTypes.any,
}
export default withTranslation()(TempoMedio)
